import { BudgetResetTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/BudgetResetTypeSelect/BudgetResetTypeSelect.utils';
import { MealCreditLength } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { MealCreditInstanceType } from 'src/types/LineOfCredit';

interface GetInstanceTypeParams {
  budgetLength: MealCreditLength;
  budgetResetType: BudgetResetTypeValues;
}

export function getInstanceType({
  budgetLength,
  budgetResetType,
}: GetInstanceTypeParams): MealCreditInstanceType {
  switch (budgetLength) {
    case MealCreditLength.WEEKLY:
      return MealCreditInstanceType.WEEKLY;
    case MealCreditLength.CUSTOM:
      return budgetResetType === BudgetResetTypeValues.MONTHS
        ? MealCreditInstanceType.MONTHLY
        : MealCreditInstanceType.WEEKLY;
    case MealCreditLength.MONTHLY:
      return MealCreditInstanceType.MONTHLY;
    case MealCreditLength.DAILY:
    default:
      return MealCreditInstanceType.DAILY;
  }
}
